// these properties will be available from anywhere via this.property
export const constants = {
  isTouch: function () {
    let isTouch = "ontouchstart" in window;

    document.body.classList.add((isTouch ? '' : 'no-') + "touch");
    return isTouch;
  }()
};


// WEBPACK FOOTER //
// ./assets/js/modules/module.js